// export const API_BASE_URL = "https://apis.hellopicbot.com/api/"
// export const API_BASE_URL = "https://apis.hellopicbot.com/getgabs/api/"
// export const API_BASE_URL = "http://192.168.40.30/hellopicbot/api/"

const hostname =
  typeof window !== "undefined" ? window.location.hostname : "";

export const API_BASE_URL =
  hostname === "localhost" || hostname === "127.0.0.1"
    ? "http://localhost:8500/picbot_with_postgre/api/"
    : hostname.includes("staging")
    ? "https://staging-apis.hellopicbot.com/api/"
    : "https://apis.hellopicbot.com/api/";


export const WEB_BASE_URL =
  hostname === "localhost" || hostname === "127.0.0.1"
    ? "http://localhost/"
    : hostname.includes("staging")
    ? "https://staging-picbot.godreamcast.com/"
    : "https://picbot.godreamcast.com/";
    
export const FORM_DATE_FORMAT = "MMM DD, YYYY";
export const FORM_TIME_FORMAT = "HH:mm A";
export const FORM_DATE_TIME_FORMAT = "MMM DD, YY HH:mm A";

export const EVENT_NAME_REGEX = /^[a-zA-Z0-9]+$/;
export const HASTAG_REGEX =
  /^[a-zA-Z0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?`~\s]*$/;

export const GOOGLE_DRIVE_LINK_REGEX =
  /(?:https?:\/\/)?drive\.google\.com\/drive\/folders\/([a-zA-Z0-9_-]+)(\?.*)?/;
export const DROPBOX_LINK_REGEX =
  /^https:\/\/www\.dropbox\.com\/scl\/(fi|fo)\/[a-zA-Z0-9]+\/[^?\s]+(\?[^\s]*)?$/;

export const FIRST_MESSAGE =
  "Hello PicBot, I am from and I would love to get my event photos & share the one clicked by me";

export const StatusFilterOptions = [
  {
    value: "",
    label: "All",
    selected: true,
  },
  {
    value: "Past",
    label: "Past",
  },
  {
    value: "Upcoming",
    label: "Upcoming",
  },
  {
    value: "Ongoing",
    label: "Ongoing",
  },
  {
    value: "Deleted",
    label: "Deleted",
  },
];
